import { Controller } from "remult";

@Controller("call-center-chat-message-methods")
export class CallCenterChatMessageMethods {}
